"use strict";

(function () {
  const refFunc = function () {
    const cn = 'd3f6e4a5';
    if (window.hasOwnProperty('kvik_dataLayerCurrentConsent') && window.kvik_dataLayerCurrentConsent().analytics_storage === 'denied') {
      console.debug(cn + ': cookie analytics_storage not granted');
      return;
    }
    if (!document.cookie.split('; ').find(row => row.startsWith(`${cn}=`))) {
      let ref = '';
      if (window.hasOwnProperty('kvik_urlQueryParamReferrer')) {
        ref = window.kvik_urlQueryParamReferrer() ?? '';
      }
      if (!ref) {
        ref = document.referrer;
      }
      if (!ref) {
        return;
      }
      const refHost = new URL(ref).hostname;
      const curHost = window.location.hostname;
      const w = {
        // vw: window.innerWidth,
        // vh: window.innerHeight,
        // sw: screen.width,
        // sh: screen.height,
        // dpr: window.devicePixelRatio,
      };
      if (ref && refHost !== curHost) {
        w.r = ref;
      }
      document.cookie = `${cn}=${encodeURIComponent(btoa(JSON.stringify(w)))}; path=/; max-age=${60 * 60 * 24}; SameSite=Lax`;
    }
  };
  refFunc();
  document.addEventListener('consent_default', refFunc);
  document.addEventListener('consent_update', refFunc);
})();

// jQuery free